import { FC, useContext } from 'react';

import { BonusIcon, Separator } from '@smartshell/ui-kit';
import { UseFormWatch } from 'react-hook-form';

import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { EDepositType, IFormValues } from '../interfaces';
import { calcTotalPrice } from '../utils';
import s from './PaymentPreview.module.scss';

interface IPaymentPreviewProps {
  watch: UseFormWatch<IFormValues>;
  type?: EDepositType;
}

export const PaymentPreview: FC<IPaymentPreviewProps> = ({ watch, type }) => {
  const {
    state: {
      settings: { currency, isBonusSystemEnabled },
    },
  } = useContext(SettingsContext);
  const { t } = useContext(LocalizationContext);
  const sum = watch('sum');
  const promoCode = watch('promoCode')?.value.value;
  const promoType = watch('promoCode')?.value?.type;

  const total = sum && calcTotalPrice(sum, promoCode);

  return (
    <div className={s.total}>
      <Separator />

      <div className={s.summary}>
        {type !== EDepositType.BONUS && (
          <FeatureHOC alias="discounts">
            <div className={s['promo-code-value']}>
              {t('promoCode')}
              {promoCode && (
                <div className={s.promoCodeSum}>
                  <span>+ {promoCode}</span>
                  {promoType === 'DEPOSIT' ? (
                    <span>{currency?.sign}</span>
                  ) : !isBonusSystemEnabled ? (
                    <span>{currency?.sign}</span>
                  ) : (
                    <BonusIcon color="violet" size="s" />
                  )}
                </div>
              )}
            </div>
          </FeatureHOC>
        )}

        {type === EDepositType.DEPOSIT && (
          <div className={s.deposit}>
            {t('deposit.fill.preview.onDeposit')}
            <span>
              {sum
                ? `${isBonusSystemEnabled ? sum : total} ${currency.sign}`
                : '—'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
